import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

/**
 * Scroll-reveal: the element starts hidden (`.reveal`) and gets `.is-visible` the
 * first time it enters the viewport, which plays the fade-up in styles.css. Cards
 * inside a `.reveal-stagger` container follow one after another.
 *
 * The observer's root is the viewport, so it works for both the desktop page
 * scroller and the phone document scroll. Without IntersectionObserver, or with
 * reduced motion, the element is shown immediately.
 */
@Directive({ selector: '[appReveal]', standalone: true })
export class RevealDirective implements OnInit, OnDestroy {
  private io?: IntersectionObserver;

  constructor(private el: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngOnInit(): void {
    const node = this.el.nativeElement;
    node.classList.add('reveal');
    const reduce = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') { node.classList.add('is-visible'); return; }

    // Class toggles only — no change detection needed.
    this.zone.runOutsideAngular(() => {
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        node.classList.add('is-visible');
        this.io?.disconnect();
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      this.io.observe(node);
    });
  }

  ngOnDestroy(): void { this.io?.disconnect(); }
}
